export default __webpack_public_path__ + "static/media/Project-2-SingleProject-MainImg.de8724ab.png";